module.exports = __webpack_public_path__ + "img/959.1bd3f776.png";